// Environment configuration
const N1CO_ENVIRONMENT = import.meta.env.VITE_N1CO_ENVIRONMENT || "sandbox";

// Sandbox configuration
const SANDBOX_CONFIG = {
  baseUrl: import.meta.env.VITE_N1CO_BASE_URL!,
  clientId: import.meta.env.VITE_N1CO_CLIENT_ID!,
  clientSecret: import.meta.env.VITE_N1CO_CLIENT_SECRET!,
};

// Production configuration
const PRODUCTION_CONFIG = {
  baseUrl: import.meta.env.VITE_N1CO_PROD_BASE_URL!,
  clientId: import.meta.env.VITE_N1CO_PROD_CLIENT_ID!,
  clientSecret: import.meta.env.VITE_N1CO_PROD_CLIENT_SECRET!,
};

// Select configuration based on environment
const getCurrentConfig = () => {
  return N1CO_ENVIRONMENT === "production" ? PRODUCTION_CONFIG : SANDBOX_CONFIG;
};

const config = getCurrentConfig();

export const N1CO_BASE_URL = config.baseUrl;
export const N1CO_CLIENT_ID = config.clientId;
export const N1CO_CLIENT_SECRET = config.clientSecret;
export const N1CO_CURRENT_ENVIRONMENT = N1CO_ENVIRONMENT;

// Validation
if (!N1CO_BASE_URL || !N1CO_CLIENT_ID || !N1CO_CLIENT_SECRET) {
  throw new Error(
    `Faltan vars de entorno de N1co para el ambiente: ${N1CO_ENVIRONMENT}`
  );
}
